import { z } from 'zod';

// Base schema for all service configurations
const serviceConfigSchema = z.object({
    supported: z.boolean(),
});

export { serviceConfigSchema };
//# sourceMappingURL=SharedServiceConfig.js.map
